import { AcUnitOutlined } from '@mui/icons-material';
import { createSlice, createAction, createAsyncThunk, createSelector } from '@reduxjs/toolkit';

import { API } from '../../api';


const NAME = 'queue';


const queueCelebrate = createAction('queue/celebrate');
const queueCelebrateFinish = createAction('queue/celebrateFinish');


/* we have this so we can mimic the old mentor lists */
export const selectMentorRequests =  (state) => {
//	console.log("selectMentorRequests: %o", state.queue.mentor.keys.map( (key) => state.queue.byRequestKey[key] ));

	if(!state.queue.mentor.keys) return [];
//	return state.queue.entities.filter( (e) => e.meta.type == 'mentor' ).map( (m) => m.data );
	return state.queue.mentor.keys;
};

/* we have this so we can mimic the old unclaimed lists */
export const selectUnclaimedRequests =  (state) => {
	if(!state.queue.unclaimed.keys) return [];
	return state.queue.unclaimed.keys;
};

/* we have this so we can mimic the old claimed lists */
export const selectClaimedRequests =  (state) => {
	if(!state.queue.claimed.keys) return [];
	return state.queue.claimed.keys;
};


/* we have this so we can mimic the old live lists */
export const selectLiveRequests =  (state) => {
	if(!state.queue.live.keys) return [];
	return state.queue.live.keys;
};

/* we have this so we can mimic the old assigned lists */
export const selectAssignedRequests =  (state) => {
//	console.log("selectAssignedRequests state: %o", state);	
	if(!state.queue.entities) return [];
	return state.queue.entities.filter( (e) => e.meta.type == 'assigned' ).map( (m) => m.data );
};

/* we have this so we can mimic the old call lists */
export const selectCallRequests =  (state) => {
//	console.log("selectCallRequests state: %o", state);
	if(!state.queue.entities) return [];
	return state.queue.entities.filter( (e) => e.meta.type == 'call' ).map( (m) => m.data );
};



const loadQueue = createAsyncThunk(
	NAME + "/loadQueue",
	async (data, thunkAPI)  => {
		return API.queue.load();
	},
	{
		// don't load if we're already loading
		condition: (data, { getState }) => {
			const queue = getState().queue;
			return queue.status != 'loading';
		}
	}
);


const loadLive = createAsyncThunk(
	NAME + "/loadLive",
	async (cursor, thunkAPI)  => {
		return API.queue.loadLive(cursor);
	},
	{
		// don't load if we're already loading
		condition: (data, { getState }) => {
			const queue = getState().queue;
			return queue.live.status != 'loading';
		}
	}
);

const loadUnclaimed = createAsyncThunk(
	NAME + "/loadUnclaimed",
	async (cursor, thunkAPI)  => {
		return API.queue.loadUnclaimed(cursor);
	},
	{
		// don't load if we're already loading
		condition: (data, { getState }) => {
			const queue = getState().queue;
			return queue.unclaimed.status != 'loading';
		}
	}
);

const loadClaimed = createAsyncThunk(
	NAME + "/loadClaimed",
	async (cursor, thunkAPI)  => {
		return API.queue.loadClaimed(cursor);
	},
	{
		// don't load if we're already loading
		condition: (data, { getState }) => {
			const queue = getState().queue;
			return queue.claimed.status != 'loading';
		}
	}
);


const loadMentor = createAsyncThunk(
	NAME + "/loadMentor",
	async (cursor, thunkAPI)  => {
		return API.queue.loadMentor(cursor);
	},
	{
		// don't load if we're already loading
		condition: (data, { getState }) => {
			const queue = getState().queue;
			return queue.mentor.status != 'loading';
		}
	}
);

const dismissEntity = createAsyncThunk(
	NAME + "/dismiss",
	async (data, thunkAPI)  => {
		let d = API.queue.dismiss(data);
		console.log("dismissEntity: %o", d);
		return d;
	}
);



const queueSlice = createSlice({
	name: NAME,
	initialState: { entities: [],
					mentor: { status: "init", keys: [] },
					unclaimed: { status: "init", keys: [] },
					claimed: { status: "init", keys: [] },					
					live: { status: "init", keys: [] },
					byRequestKey: {},
					celebrate: null,					
					status: "init" },

	reducers: {
		celebrate: (state, action) => {
			state.celebrate = action.payload;
		},
		celebrateFinish: (state, action) => {
			state.celebrate = null;

		},
		dismiss: (state, action) => {
			console.log("OLd DISMIKSS!!");
		},
	},

	extraReducers: {
		[loadMentor.pending]: (state, action) => {
			state.mentor.status = "loading";
		},
		[loadMentor.fulfilled]: (state, action) => {
//			console.log("loadMentor, fullfilled: %o", action);
			state.mentor.status = "idle";

			action.payload.requests.forEach((r) => {
				// ignore requests that are already being mentored.
				if(!r.mentor_claimed) {
					state.mentor.keys.push(r.key);
				}
			});
			
			action.payload.requests.forEach((e) => {
				state.byRequestKey[e.key] = e;
			});


			state.mentor.keys.sort((a, b) => {
				return new Date(state.byRequestKey[a].date_updated) - new Date(state.byRequestKey[b].date_updated);
			});

		},

		[loadLive.pending]: (state, action) => {
			state.live.status = "loading";
		},
		[loadLive.fulfilled]: (state, action) => {
			state.live.status = "idle";

			action.payload.requests.forEach((r) => {
				state.live.keys.push(r.key);
			});
			
			action.payload.requests.forEach((e) => {
				state.byRequestKey[e.key] = e;
			});
		},
		[loadClaimed.pending]: (state, action) => {
			state.claimed.status = "loading";
		},
		[loadClaimed.fulfilled]: (state, action) => {
			state.claimed.status = "idle";
			console.log("Loading claimed... action: %o", action);
//			console.log(action)
			if(!action.payload.requests.length)
				return;

			action.payload.requests.forEach((r) => {
				state.claimed.keys.push(r.key);
			});

			action.payload.requests.forEach((e) => {
				state.byRequestKey[e.key] = e;
			});

			state.claimed.keys.sort((a, b) => {
				return new Date(state.byRequestKey[a].date_created) - new Date(state.byRequestKey[b].date_created);
			});

		},
		
		[loadUnclaimed.pending]: (state, action) => {
			state.unclaimed.status = "loading";
		},

		[loadUnclaimed.fulfilled]: (state, action) => {
			state.unclaimed.status = "idle";

			if(!action.payload.requests.length)
				return;

			action.payload.requests.forEach((r) => {
				state.unclaimed.keys.push(r.key);
			});

			action.payload.requests.forEach((e) => {
				state.byRequestKey[e.key] = e;
			});

			state.unclaimed.keys.sort((a, b) => {
				return new Date(state.byRequestKey[a].date_created) - new Date(state.byRequestKey[b].date_created);
			});

		},

		"NOTIFICATION_REQUEST_AVAILABLE": (state, action) => {
			action.data.meta.requests.forEach((r) => {
				state.byRequestKey[r.key] = r;
				state.unclaimed.keys.push(r.key);
			});
		},
		"NOTIFICATION_MENTOR_REQUEST_AVAILABLE": (state, action) => {
			action.data.meta.requests.forEach((r) => {
				state.byRequestKey[r.key] = r;
				state.mentor.keys.push(r.key);
			});
		},

		"NOTIFICATION_REQUEST_UNAVAILABLE": (state, action) => {
			let keysToRemove = action.data.meta.requests.map((r) => r.key);
			state.unclaimed.keys = state.unclaimed.keys.filter((k) => keysToRemove.indexOf(k) === -1);
		},


		"NOTIFICATION_MENTOR_REQUEST_UNAVAILABLE": (state, action) => {
			let keysToRemove = action.data.meta.requests.map((r) => r.key);
			state.mentor.keys = state.mentor.keys.filter((k) => keysToRemove.indexOf(k) === -1);
		},

		[loadQueue.pending]: (state, action) => {
			state.status = "loading";
		},
		[loadQueue.fulfilled]: (state, action) => {
			console.warn(action);
			state.status = "idle";
			state.entities = action.payload.entities; // we're replacing the entire queue
			state.entities.forEach((e) => {
				state.byRequestKey[e.data] = e;
			});
		},

		[loadQueue.rejected]: (state, action) => {
			state.status = "error";			
		},


		[dismissEntity.pending]: (state, action) => {
			state.status = "dismissing";
		},		
		[dismissEntity.fulfilled]: (state, action) => {
			state.entities = state.entities.filter((o) => o.data != action.payload);
			state.status = "idle";			
		}
	}
					
});

export { queueCelebrate, queueCelebrateFinish, dismissEntity, loadQueue, loadMentor, loadUnclaimed, loadLive, loadClaimed };
export default queueSlice.reducer;
